import React from 'react';
import PropTypes from 'prop-types';
import { useQuery } from '@apollo/client';

import { Spinner } from 'admin-components/components';
import { useManagedMutation } from 'utils/managedHooks';
import { hotelShape } from 'constants/propTypes';

import { CANCEL_HOTEL_PRODUCT } from 'store/mutations';
import { GET_CANCEL_HOTEL_REFUND_PROPOSAL, GET_HOTEL_BOOKINGS_INFO, GET_HOTEL_REFUND_PROPOSAL, HOTEL_BOOKING } from 'store/queries';

import ManageHotel from 'pages/BookingDetails/Extras/ExtrasHotel/ManageHotel/ManageHotel';
import { findJacTravelHotel } from '../../../../utils/booking';
import { buildHotelInfoFromDotwBooking } from '../../../../utils/hotel';

const CancelHotel = ({ jacTravelRef, hotel, bookingReference, isPackage }) => {
  const [cancelHotelProduct, { loading }] = useManagedMutation(CANCEL_HOTEL_PRODUCT, {
    refetchQueries: ['booking'],
    awaitRefetchQueries: true
  });

  const {
    data,
    loading: refundLoading,
    error: refundProposalError
  } = useQuery(hotel.isDotwBooking ? GET_CANCEL_HOTEL_REFUND_PROPOSAL : GET_HOTEL_REFUND_PROPOSAL, {
    variables: hotel.isDotwBooking ? { reference: bookingReference } : { bookingReference },
    skip: !hotel.canBeCancelledOnThirdParty
  });

  const { data: hotelsData } = useQuery(hotel.isDotwBooking ? HOTEL_BOOKING : GET_HOTEL_BOOKINGS_INFO, {
    variables: hotel.isDotwBooking ? { reference: bookingReference } : { bookingReference }
  });

  const jacTravelHotel = hotel.isDotwBooking
    ? buildHotelInfoFromDotwBooking(hotelsData?.hotelBooking)
    : hotelsData?.getHotelBookings && findJacTravelHotel(jacTravelRef, hotelsData.getHotelBookings);

  const jacTravelTotalPrice = jacTravelHotel?.totalPrice;
  const jacTravelTotalCommission = jacTravelHotel?.totalCommission;

  const handleCancel = async ({ fee, marginFee }) => {
    await cancelHotelProduct({
      variables: {
        bookingReference,
        fee,
        marginFee,
        itemRef: hotel.itemRef,
        skipConfirmation: true
      }
    });
  };

  if (hotel.cancelled && hotel.provisional) {
    return null;
  }

  if (refundLoading) {
    return <Spinner />;
  }

  return hotel ? (
    <ManageHotel
      currency={hotel.currency}
      margin={hotel.margin}
      date={hotel.checkInDate}
      hotelId={hotel.hotelId}
      isConfirmed
      jacTravelRef={jacTravelRef}
      jacTravelTotalPrice={jacTravelTotalPrice}
      jacTravelTotalCommission={jacTravelTotalCommission}
      loading={loading}
      price={hotel.priceWithMargin}
      onCancel={handleCancel}
      canExchange={false}
      refundProposal={data && data.refundProposal}
      refundProposalError={!!refundProposalError}
      isPackage={isPackage}
      isHotelOnly={!isPackage}
      canBeCancelledOnThirdParty={hotel.canBeCancelledOnThirdParty}
    />
  ) : (
    <Spinner />
  );
};

CancelHotel.propTypes = {
  hotel: hotelShape.isRequired,
  jacTravelRef: PropTypes.string,
  bookingReference: PropTypes.string.isRequired,
  isPackage: PropTypes.bool.isRequired
};

export default CancelHotel;
